import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Cashier  {
    _originalTypeClassName = "zERP.BO.Cashier";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Cashier.translate = translateService;
}
this.Id = null;
this.Code = null;
this.Name = null;
this.Surname = null;
this.Fullname = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
Name:any;
Surname:any;
Fullname:any;
CashAccount:any;
AccountingConfig:any;
Entity:any;
static setCashAccount = ($this, value) => {
var oldValue = $this.CashAccount;
$this.CashAccount = value;
if (value != null) {
}
}
static setAccountingConfig = ($this, value) => {
var oldValue = $this.AccountingConfig;
$this.AccountingConfig = value;
if (value != null) {
}
}
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}

static GetClassName(): any{return "Cashier";
}
static GetFullname($this: any): any{return $this?.Name + " " + $this?.Surname;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}